import { ADD_FOLDER, DEL_FILE, RENAME_FILE, WRITE_FILE } from './actions';
import createFileStore from './files-store';
import { IPromisesAPI } from 'memfs/lib/promises'; // unnecessary dependency..


/**
 * @name ObjectFs
 * @description
 * adapter class: node.fs <--> store<FilesState>
 * ObjectFs is a *subset* of node.fs
 */

// => all methods in Object must(!) be in the node.fs.promises interface

export class ObjectFs {
	protected store = createFileStore();

	//@ts-ignore
	promises = new ObjectFsPromises(this) as IPromisesAPI;

	//HACK! use pathname
	//TODO - add tests
	readdirSync = (pathname: string) => {
		const state = this.store.getState();
		const { files } = state;

		if (!files) return Promise.resolve([]);
		return Promise.resolve(Object.keys(files));
	};

	writeFileSync = (path: string, content: string = '') => {
		this.store.dispatch({
			type: WRITE_FILE,
			fileId: path,
			content,
		});
	};

	//should throw if not found?
	readFileSync = (path: string) => {
		const state = this.store.getState();
		const { files } = state;
		if (!files || !files.hasOwnProperty(path)) return undefined;

		const file = files[path];
		if (!file || !file.isFile) return undefined;
		if (typeof file.source !== 'string') return undefined;

		return file.source;
	};

	mkdirSync = (path: string) => {
		if (path === '.') return;

		return this.store.dispatch({
			type: ADD_FOLDER,
			fileId: path,
		});
	};

	unlinkSync = (path: string) => {
		this.store.dispatch({
			type: DEL_FILE,
			fileId: path,
		});
	};

	renameSync = (oldPath: string, newPath: string) => {
		this.store.dispatch({
			type: RENAME_FILE,
			prevId: oldPath,
			nextId: newPath,
		});
	};

	//TODO - store feature. replace with fs.watch()
	subscribe = (listener: () => void) => {
		return this.store.subscribe(listener);
	};
}

class ObjectFsPromises {
	constructor(private fs: ObjectFs) {}

	readdir = (pathname: string) => Promise.resolve().then(() => this.fs.readdirSync(pathname));

	writeFile = (path: string, content: string = '') =>
		Promise.resolve().then(() => this.fs.writeFileSync(path, content));

	readFile = (path: string) => Promise.resolve().then(() => this.fs.readFileSync(path));

	mkdir = (path: string) => Promise.resolve().then(() => this.fs.mkdirSync(path));

	unlink = (path: string) => Promise.resolve().then(() => this.fs.unlinkSync(path));

	rename = (oldPath: string, newPath: string) =>
		Promise.resolve().then(() => this.fs.renameSync(oldPath, newPath));
}
